import { call, put, takeEvery } from 'redux-saga/effects'
import * as type from '../../types';
import { loginApi } from '../../api/common/authApi';

function* fetchLoginSaga(action) {
  try {
      const data = yield call(loginApi, action.payload);
      yield put({ type: type.FETCH_LOGIN_SUCCESS, data });
  } catch (error) {
      yield put({
          type: type.FETCH_LOGIN_FAILURE,
          message: error.response?.data?.message || "Invalid credentials",
          status: error.response?.status || 500  // Capture the HTTP status
      });
  }
}

 


export function* watchFetchLoginSaga() {
    yield takeEvery(type.FETCH_LOGIN, fetchLoginSaga);
}
 
// import { call, put, takeEvery } from 'redux-saga/effects'
// import * as type from '../../types';
// import { loginApi } from '../../api/common/authApi';

// function* fetchLoginSaga(action) {
//     try {
//        const data = yield call(loginApi, action.payload);
//        yield put({type: type.FETCH_LOGIN_SUCCESS, data});
//     } catch (e) {
//        yield put({type: type.FETCH_LOGIN_FAILURE, message: e.message});
//     }
// }
 


// export function* watchFetchLoginSaga() {
//     yield takeEvery(type.FETCH_LOGIN, fetchLoginSaga);
// }
 